import {
  // oxlint-disable-next-line no-restricted-imports
  Button as MantineButton,
  ButtonProps as MantineButtonProps,
} from "@mantine/core";
import { forwardRef, MouseEventHandler } from "react";

import classes from "./Button.module.css";

export type ButtonProps = MantineButtonProps & {
  icon?: React.ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: "submit";
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = "filled", icon = null, onClick, color, ...props }, ref) => {
    const filled = variant === "filled";

    return (
      <MantineButton
        ref={ref}
        leftSection={icon}
        variant={variant}
        onClick={onClick}
        loaderProps={{ color: filled ? "white" : "black" }}
        color={color}
        classNames={classes}
        {...props}
      >
        {children}
      </MantineButton>
    );
  },
);
